import { useCallback, useEffect, useMemo, useState } from "react";
import { ROUTES } from "../../consts";
import { useTrackContext } from "../../hooks/useTrackContext";
import { ProductSelection } from "../common/ProductSectionAndDate";
import Notification from "../Notification";
import ProgressBar from "../ProgressiveBar";
import { IGVariant } from "../../types";
import NewsletterPopup from "../NewsletterPopup";
// import ModalWithAccordion from "../ModalAccordion";
import BookingKeyModal from "./BookingKeyModal";
import MiniCart from "../Cart/MiniCart";
import VideoDisplayModal from "./videoDisplayModal";
import BattleRaceIcon from "./SVGIcons/BattleRaceIcon";
import BattleColourIcon from "./SVGIcons/BattleColourIcon";
import BattleKartFootSVGIcon from "./SVGIcons/BattleKartFootSVGIcon";
import BattleSnakeIcon from "./SVGIcons/BattleSnakeIcon";
import BottomSummary from "../BottomSummary";

const BattleKartTrack = ({
  selectProductOnly,
  onVariantSelection,
}: {
  selectProductOnly?: boolean;
  onVariantSelection?: (isAdded: boolean, variant: IGVariant, selectedVariants: IGVariant[]) => void;
}) => {
  const {
    battleKartSelection,
    windowWidth,
    productRenderedLocation,
    isProductLoading,
    // termsAndConditionsContent,
    metaObjectBattleKartTrackSectionConfig: {
      calenderAndTimeslotSection: { gamesConfig },
    },
  } = useTrackContext();
  const [isActive, setIsActive] = useState<boolean>(true);
  const [showBookingKeyModal, setShowBookingKeyModal] = useState<boolean>(true);
  const [showVideoModal, setShowVideoModal] = useState<boolean>(false);
  const [videoUrl, setVideoUrl] = useState<string>("");
  const [game, setGame] = useState<"battleRace" | "battleColour" | "battleFoot" | "battleSnake" | "battleVirus">("battleRace");

  useEffect(() => {
    if (battleKartSelection.variantsAndDate.selectedVariants.length === battleKartSelection.racesSeats.numberOfRaces) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [battleKartSelection]);

  const numberOfSelectedVariants: number = useMemo(() => {
    return battleKartSelection.variantsAndDate.selectedVariants.length;
  }, [battleKartSelection.variantsAndDate.selectedVariants]);

  const numberOfRaces: number = useMemo(() => {
    return battleKartSelection.racesSeats.numberOfRaces;
  }, [battleKartSelection.racesSeats.numberOfRaces]);

  // Add this new computed value for styling logic
  const isAllSessionsSelected = numberOfSelectedVariants === numberOfRaces;

  const handleGameVideoModal = useCallback(
    (game: "battleRace" | "battleColour" | "battleFoot" | "battleSnake" | "battleVirus") => {
      if (gamesConfig && gamesConfig[game]) {
        if (gamesConfig[game].videoUrl) {
          setShowVideoModal(true);
          setVideoUrl(gamesConfig[game].videoUrl);
          setGame(game);
        }
      }
    },
    [gamesConfig]
  );

  if (selectProductOnly) {
    return <ProductSelection selectProductOnly={selectProductOnly} onVariantSelection={onVariantSelection} />;
  }

  return (
    <>
      <BookingKeyModal isOpen={showBookingKeyModal} onClose={() => setShowBookingKeyModal(false)} />
      <VideoDisplayModal isOpen={showVideoModal} game={game} onClose={() => setShowVideoModal(false)} videoUrl={videoUrl} />
      <div className="tw-relative">
        <Notification />
      </div>
      <ProgressBar maxValue={100} currentValue={windowWidth <= 768 ? 90 : 75} />
      {productRenderedLocation === "external" && <MiniCart />}
      <div className="tw-block lg:tw-hidden">
        {/* <span className="tw-block tw-text-[18px] lg:tw-text-[24px] tw-text-[#EA581A] tw-font-[700] tw-mt-[30px] tw-text-center add-grobold-font">Battle Kart Track</span> */}
        {/* <div className="tw-text-white tw-text-center tw-text-[24px] tw-font-extrabold add-grobold-font">Select your Date, Time And Game Modes</div> */}

        <div className="tw-mt-[10px] tw-justify-center tw-hidden xl:tw-flex tw-hidden">
          {isAllSessionsSelected ? (
            <div className="tw-relative tw-w-fit tw-py-[5px] tw-px-[16px] tw-rounded-[16px]" style={{ background: "linear-gradient(180deg, #FAC618 0%, #EA581A 100%)" }}>
              <span className="tw-font-[400] tw-text-[14px] add-source-sans-pro-font tw-text-white">
                {numberOfSelectedVariants} out of {numberOfRaces} sessions selected
              </span>
            </div>
          ) : (
            <div className="tw-relative tw-w-fit tw-p-[2px] tw-rounded-[16px]" style={{ background: "linear-gradient(180deg, #FAC618 0%, #EA581A 100%)" }}>
              <div className="tw-bg-white tw-py-[3px] tw-px-[14px] tw-rounded-[14px]">
                <span className="tw-font-[400] tw-text-[14px] add-source-sans-pro-font tw-text-black">
                  {numberOfSelectedVariants} out of {numberOfRaces} sessions selected
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="tw-hidden lg:tw-block">
        {/* <p className="tw-block tw-text-white tw-font-extrabold tw-text-[24px] lg:tw-text-[34px] add-grobold-font tw-text-center">Select your Date, Time And Game Modes</p> */}

        <div className="tw-mt-[10px] tw-flex tw-justify-center tw-hidden">
          {isAllSessionsSelected ? (
            <div className="tw-relative tw-w-fit tw-py-[5px] tw-px-[16px] tw-rounded-[16px]" style={{ background: "linear-gradient(180deg, #FAC618 0%, #EA581A 100%)" }}>
              <span className="tw-font-[400] tw-text-[14px] add-source-sans-pro-font tw-text-white">
                {numberOfSelectedVariants} out of {numberOfRaces} sessions selected
              </span>
            </div>
          ) : (
            <div className="tw-relative tw-w-fit tw-p-[2px] tw-rounded-[16px]" style={{ background: "linear-gradient(180deg, #FAC618 0%, #EA581A 100%)" }}>
              <div className="tw-bg-white tw-py-[3px] tw-px-[14px] tw-rounded-[14px]">
                <span className="tw-font-[400] tw-text-[14px] add-source-sans-pro-font tw-text-black">
                  {numberOfSelectedVariants} out of {numberOfRaces} sessions selected
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      <ProductSelection />

      <div className="tw-mt-[10px] tw-flex tw-justify-center xl:tw-hidden tw-hidden">
        {isAllSessionsSelected ? (
          <div className="tw-relative tw-w-fit tw-py-[5px] tw-px-[16px] tw-rounded-[16px]" style={{ background: "linear-gradient(180deg, #FAC618 0%, #EA581A 100%)" }}>
            <span className="tw-font-[400] tw-text-[14px] add-source-sans-pro-font tw-text-white">
              {numberOfSelectedVariants} out of {numberOfRaces} sessions selected
            </span>
          </div>
        ) : (
          <div className="tw-relative tw-w-fit tw-p-[2px] tw-rounded-[16px]" style={{ background: "linear-gradient(180deg, #FAC618 0%, #EA581A 100%)" }}>
            <div className="tw-bg-white tw-py-[3px] tw-px-[14px] tw-rounded-[14px]">
              <span className="tw-font-[400] tw-text-[14px] add-source-sans-pro-font tw-text-black">
                {numberOfSelectedVariants} out of {numberOfRaces} sessions selected
              </span>
            </div>
          </div>
        )}
      </div>

      <div className="tw-flex tw-justify-center tw-pb-[40px] tw-mb-[20px] lg:tw-pb-[0px] lg:tw-mt-[30px] lg:tw-mb-[40px]">
        <div className="tw-text-center lg:tw-transform lg:tw-translate-x-[25%] xl:tw-transform xl:tw-translate-x-[86%]">
          {!isProductLoading && (
            <>

              <div className="tw-flex tw-flex-col tw-items-center">
                <div className="tw-flex tw-gap-[6px] tw-mb-[5px] lg:tw-mb-[10px]">
                  <div
                    className="tw-relative tw-w-[60px] tw-h-[60px] md:tw-w-[80px] md:tw-h-[80px] tw-rounded-[8px] tw-overflow-hidden tw-cursor-pointer"
                    onClick={() => handleGameVideoModal("battleRace")}
                  >
                    <BattleRaceIcon />
                  </div>

                  <div
                    className="tw-relative tw-w-[60px] tw-h-[60px] md:tw-w-[80px] md:tw-h-[80px] tw-rounded-[8px] tw-overflow-hidden tw-cursor-pointer"
                    onClick={() => handleGameVideoModal("battleSnake")}
                  >
                    <BattleSnakeIcon />
                  </div>

                  <div
                    className="tw-relative tw-w-[60px] tw-h-[60px] md:tw-w-[80px] md:tw-h-[80px] tw-rounded-[8px] tw-overflow-hidden tw-cursor-pointer"
                    onClick={() => handleGameVideoModal("battleColour")}
                  >
                    <BattleColourIcon />
                  </div>

                  <div
                    className="tw-relative tw-w-[60px] tw-h-[60px] md:tw-w-[80px] md:tw-h-[80px] tw-rounded-[8px] tw-overflow-hidden tw-cursor-pointer"
                    onClick={() => handleGameVideoModal("battleFoot")}
                  >
                    <BattleKartFootSVGIcon />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-center tw-items-center tw-gap-[12px] md:tw-gap-[20px] tw-mb-[60px] md:tw-mb-0 tw-mt-[80px] tw-px-[10px] tw-hidden">
        <div className="tw-flex tw-items-center tw-gap-[8px] tw-text-center tw-hidden">
          <input type="checkbox" id="privatize-sessions" className="tw-w-[16px] tw-h-[16px]" style={{ accentColor: "#EA581A" }} />
          <label htmlFor="privatize-sessions" className="tw-text-white tw-text-[12px] md:tw-text-[14px] tw-cursor-pointer add-source-sans-pro-font">
            Do you want to privatize your sessions?
          </label>
          <svg className="tw-w-[16px] tw-h-[16px] tw-text-white tw-cursor-pointer" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>

      <div className="tw-w-full lg:tw-h-[126px] tw-p-[30px] tw-mt-[40px] lg:tw-mt-0">
        <div className="tw-flex tw-justify-center tw-items-center">
          <div
            className={`${
              productRenderedLocation === "external" ? "tw-container tw-mx-auto" : "container mx-auto"
            } tw-relative tw-flex tw-justify-end tw-items-center tw-gap-[15px] lg:tw-block`}
          >
            <NewsletterPopup />
          </div>
        </div>
      </div>
      <BottomSummary
        previousInfo={{ pageName: "Players and Sessions", pagePath: "/" + ROUTES.BATTLE_KART_TRACK.PLAYERS_SESSIONS }}
        nextInfo={{ pageName: `Review (${numberOfSelectedVariants}/${numberOfRaces})`, pagePath: "/" + ROUTES.BATTLE_KART_TRACK.ReviewCart, isActive: isActive }}
      />
    </>
  );
};

export default BattleKartTrack;
